import React from 'react';
import { FormattedMessage } from 'react-intl';

/**
 * @type {{[key in import('./types').Channel] : import('./types').Channel}}
 */
export const CHANNELS = {
  WEB: 'WEB',
  EMAIL: 'EMAIL',
  DESKTOP: 'DESKTOP',
  MOBILE: 'MOBILE',
};

/**
 * @type {{[key in import('./types').NotificationStatus] : import('./types').NotificationStatus}}
 */
export const NOTIFICATION_STATUS = {
  UNREAD: 'UNREAD',
  READ: 'READ',
};

/**
 * @type {{[key in import('./types').NotificationSettingSelect] : import('./types').NotificationSettingSelect}}
 */
export const NOTIFICATION_SETTINGS_SELECT = {
  ALL: 'ALL',
  MINE: 'MINE',
};

export const NOTIFICATION_SETTINGS_OPTIONS = [
  {
    value: NOTIFICATION_SETTINGS_SELECT.ALL,
    label: <FormattedMessage id="notifications.navigation.type.ALL" defaultMessage="Everything" />,
  },
  {
    value: NOTIFICATION_SETTINGS_SELECT.MINE,
    label: <FormattedMessage id="notifications.navigation.type.MINE" defaultMessage="My files" />,
  },
];
